import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clientService } from '@services/client';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@utils/errorMessage';
import { CLIENT_QUERY_KEY } from './useClient';
import { CLIENTS_QUERY_KEY } from './useClients';
import { useTranslation } from '@hooks/useTranslation';

// Sprint 25, story-128 (run 5). Flow D's "Remove access" and the "Replace login" first step
// (disable the old membership before inviting the new email).
export const useRemoveClientAccess = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['removeClientAccess'],
    mutationFn: async (clientId: string) => clientService.removeClientAccess(clientId),
    onSuccess: (_data, clientId) => {
      queryClient.invalidateQueries({ queryKey: CLIENT_QUERY_KEY(clientId) });
      queryClient.invalidateQueries({ queryKey: CLIENTS_QUERY_KEY });
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, tActionMessages.requestError));
    },
  });
};

export default useRemoveClientAccess;
